module.exports = __webpack_public_path__ + "static/media/G25.4d2dc156.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gp/G25.jpg
// module id = 78
// module chunks = 0